import { reduxForm } from 'redux-form';
import { I18n } from 'react-redux-i18n';

import CPFValidator from '../../validators/CPFValidator';
import EmailValidator from '../../validators/EmailValidator';


const FORM_NAME = 'AccountForm';
export const USER_TYPE = {
  ADMINISTRATOR: 1,
  OPERATOR: 2,
};

const FORM_DEFINITION = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  fields: ['name', 'userIdCreated', 'dateCreated'],
  initialValues: {
    dateCreated: new Date(),
    lstCompany: [],
  },
  validate: (values) => {


    const errors = {};
    const requiredFields = ['name', 'login', 'password', 'userTypeId', 'cpf', 'email', 'lstCompany'];
    requiredFields.forEach((field) => {

      if (values[field] == null) errors[field] = I18n.t('messages.required_field');


      if (values.cpf && values.cpf.toString().length && !CPFValidator(values.cpf))
        errors.cpf = I18n.t('messages.invalid_cpf');

      if (values.email && values.email.toString().length && !EmailValidator(values.email))
        errors.email = I18n.t('messages.invalid_email');

    });
    return errors;

  },
});

export {
  FORM_NAME,
  FORM_DEFINITION,
};



// WEBPACK FOOTER //
// ./src/components/tracker/User/index.js